module.exports = __webpack_public_path__ + "img/min-map.7f0af43b.png";